import WeekdayDetailChart from "./weekday-detail-chart"
import { weekdayDetailChartStore } from "./weekday-detail-chart-store"
import { langStore } from "@/stores/lang-store"
import { formatMessage } from "@/utils/format-message"
import { weekdayBundle } from "./weekday-const"
import Wrapper from "@/components/wrapper"

const WeekdayDetailChartModal = ({ open, onClose }) => {
  const { lang } = langStore()
  const { series, period } = weekdayDetailChartStore()

  if (!open) return null

  return (
    <Wrapper.modal
      onClose={onClose}
      className="p-6 rounded-2xl max-w-5xl w-full mx-4 border h-3/4 bg-white shadow-xl"
    >
      <div className="flex flex-col gap-6 h-full">
        <div className="flex flex-col gap-1 border-b border-gray-100 pb-3">
          <h3 className="text-xl font-bold text-gray-900">
            {weekdayBundle.detailModal.title[lang]}
          </h3>

          {period && (
            <div className="flex items-center gap-2 text-xs text-gray-400 font-medium">
              <span>{weekdayBundle.detailModal.period[lang]}</span>
              <span>
                {formatMessage(weekdayBundle.detailModal.current[lang], {
                  period: period?.current || "-"
                })}
              </span>
              <span className="text-gray-200">|</span>
              <span>
                {formatMessage(weekdayBundle.detailModal.previous[lang], {
                  period: period?.previous || "-"
                })}
              </span>
              <span className="text-gray-200">|</span>
              <span>
                {formatMessage(weekdayBundle.detailModal.twoMonth[lang], {
                  period: period?.two_month || "-"
                })}
              </span>
            </div>
          )}
        </div>

        <div className="w-full flex-1 h-0 min-h-100">
          {series && series.length > 0 ? (
            <WeekdayDetailChart series={series} />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
              {weekdayBundle.detailModal.loading[lang]}
            </div>
          )}
        </div>
      </div>
    </Wrapper.modal>
  )
}

export default WeekdayDetailChartModal
